import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const createEftStyle = {
	...customSelectStyle,
	...customCheckboxRadioSwitch
};

export default createEftStyle;
